import { render, staticRenderFns } from "./expensesDistribution.vue?vue&type=template&id=8bccb87e&"
import script from "./expensesDistribution.vue?vue&type=script&lang=js&"
export * from "./expensesDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports